// extracted by mini-css-extract-plugin
export default {"header":"MinimalLayout_header","logoLine":"MinimalLayout_logoLine","container":"MinimalLayout_container"};